<div class="page-layout blank" fusePerfectScrollbar>

    <div class="profile-header">
        <div fxLayout="row" fxLayout.xs="column" fxFlex="80" fxFlex.xs="85" fxLayoutAlign="start center"
            fxLayoutAlign.xs="center center" class="inner-container">
            <div fxLayoutAlign="center center" class="profile-image p-24">
                <fuse-upload [uploadOptions]="uploadOptionsProfileImage"></fuse-upload>
                <img *ngIf="profileImage" [src]="profileImage">
            </div>
            <div class="p-16" fxFlex>
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.xs="center center">
                    <h2 class="mb-8">{{profileData.first_name}} {{profileData.last_name}}</h2>
                    <span>{{'Profile Page' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="profile-content pb-64">
        <div fxFlex="80" fxFlex.lt-md="100" class="inner-container">
            <mat-tab-group [(selectedIndex)]="activeTabIndex">
                <mat-tab label="{{'My Data' | translate}}">
                    <div class="p-24">
                        <div fxLayout="row wrap" fxLayout.ld-md="column">
                            <div class="pb-32" fxFlex="100">
                                <h3 class="text-uppercase">{{'Basic information' | translate}}</h3>
                                <div *ngIf="basicDataNoEdit">
                                    <div fxLayout="row wrap" class="py-32" *ngIf="profileData">
                                        <table class="simple" fxFlex="40" fxFlex.lt-md="100">
                                            <tr>
                                                <td><b>{{'First Name' | translate}}</b></td>
                                                <td>{{profileData.first_name}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Last Name' | translate}}</b></td>
                                                <td>{{profileData.last_name}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Parent first name' | translate}}</b></td>
                                                <td>{{profileData.parent_first_name}}</td>
                                            </tr>
                                            <!-- <tr>
                                                <td><b>Title</b></td>
                                                <td>{{profileData.title}}</td>
                                            </tr> -->
                                            <tr>
                                                <td><b>{{'E-mail' | translate}}</b></td>
                                                <td>{{profileData.email}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Alternate email' | translate}}</b></td>
                                                <td>{{profileData.email2}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Mobile phone number' | translate}}</b></td>
                                                <td>{{profileData.phone_number}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Date of Birth' | translate}}</b></td>
                                                <td>{{profileData.date_of_birth == null ? ('Invalid Date' | translate) : dateLocale(profileData.date_of_birth)}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Landline number' | translate}}</b></td>
                                                <td>{{profileData.phone_number_fix}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Doctor' | translate}}</b></td>
                                                <td>{{profileData.doctor}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Bank account number' | translate}}</b></td>
                                                <td>{{profileData.bank_account_number}}</td>
                                            </tr>
                                        </table>

                                        <span fxFlex fxHide.lt-md></span>

                                        <table class="simple" fxFlex="40" fxFlex.lt-md="100">
                                            <tr>
                                                <td><b>{{'Identity Number' | translate}}</b></td>
                                                <td>{{profileData.identity_number || '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Residence Address' | translate}}</b></td>
                                                <td>{{profileData.residence_address || '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Declared Address' | translate}}</b></td>
                                                <td>{{profileData.declared_address || '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Residence City' | translate}}</b></td>
                                                <td>{{getCity(profileData.residenceCityName) || '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>{{'Declared City' | translate}}</b></td>
                                                <td>{{getCity(profileData.declaredCityName) || '-'}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!-- <button mat-raised-button color="accent"
                                        (click)="toggleBasicDataEdit(false)">{{'Edit' | translate}}</button> -->
                                </div>
                            </div>

                            <div class="pb-32 mt-32 border-top" fxFlex="46" fxFlex.lt-md="100">
                                <h3 class="text-uppercase">{{'Linked account' | translate }}</h3>
                                <div class="py-32" *ngIf="profileData.source === 'email'">
                                    <button mat-raised-button class="mr-8 mb-8" color="accent"
                                        (click)="attachSocial('facebook')">{{'Link Facebook account' | translate }}</button>
                                    <button mat-raised-button class="mr-8 mb-8" color="accent"
                                        (click)="attachSocial('google')">{{'Link Google account' | translate }}</button>
                                </div>
                                <div class="py-32" fxLayout="row" fxLayoutAlign="start center"
                                    *ngIf="profileData.source !== 'email'">
                                    <button mat-raised-button class="mr-8" color="accent"
                                        (click)="detachSocial(profileData.source)">{{'Unlink' | translate }}</button>
                                    <div class="text-uppercase mr-8" [ngClass]="profileData.source">
                                        {{profileData.source}}</div>
                                </div>
                            </div>

                            <span fxFlex fxHide.lt-md></span>

                            <div class="pb-32 mt-32 border-top mr-16" fxFlex="46" fxFlex.lt-md="100"
                                *ngIf="profileData.hasPassword">
                                <h3 class="text-uppercase">{{'CHANGE PASSWORD' | translate }}</h3>
                                <div class="py-32" *ngIf="!passwordDataNoEdit">

                                    <form autocomplete="off" [formGroup]="memberPasswordForm" fxFlex="75"
                                        fxFlex.lt-md="100">

                                        <div fxLayout="row" fxLayoutAlign="start start">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>{{'Old Password' | translate }}</mat-label>
                                                <mat-icon matSuffix class="secondary-text">lock</mat-icon>
                                                <input name="oldPassword" type="password" formControlName="oldPassword"
                                                    matInput required>
                                                <mat-error *ngIf="memberPasswordForm.get('oldPassword').errors">
                                                    {{'Old password is incorrect!' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="start start">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>{{'New Password' | translate }}</mat-label>
                                                <mat-icon matSuffix class="secondary-text">lock_open</mat-icon>
                                                <input name="password" type="password" formControlName="password"
                                                    matInput required>
                                                <mat-error>
                                                    {{'Must contain number, lowercase, uppercase letter and min. 8 characters' | translate }}

                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="start start">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>{{'Confirm New Password' | translate }}</mat-label>
                                                <mat-icon matSuffix class="secondary-text">lock_open</mat-icon>
                                                <input name="confirmPassword" type="password"
                                                    formControlName="confirmPassword" matInput
                                                    [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="memberPasswordForm.hasError('notSame')">
                                                    {{'Passwords do not match' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div>
                                            <button mat-raised-button class="mr-8" color="accent"
                                                (click)="togglePasswordDataEdit(true)">{{'Cancel' | translate }}</button>
                                            <button mat-raised-button class="mr-8" color="accent"
                                                (click)="savePassword(memberPasswordForm)"
                                                [disabled]="memberPasswordForm.invalid || memberPasswordForm.pristine">{{'Save' | translate }}</button>
                                        </div>

                                    </form>

                                </div>
                                <div class="py-32">

                                    <button mat-raised-button class="mr-8" color="accent" *ngIf="passwordDataNoEdit"
                                        (click)="togglePasswordDataEdit(false)">{{'Change' | translate }}</button>
                                </div>
                            </div>

                            <span fxFlex fxHide.lt-md></span>

                            <div class="pb-32 mt-32 border-top  mr-16" fxFlex="46" fxFlex.lt-md="100"
                                *ngIf="!profileData.hasPassword">
                                <h3 class="text-uppercase">{{'Create password' | translate }}</h3>
                                <div class="py-32" *ngIf="!passwordDataNoEdit">
                                    <form autocomplete="off" [formGroup]="memberFirstPasswordForm" fxFlex="75"
                                        fxFlex.lt-md="100">

                                        <div fxLayout="row" fxLayoutAlign="start start">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>{{'New Password' | translate }}</mat-label>
                                                <mat-icon matSuffix class="secondary-text">lock_open</mat-icon>
                                                <input name="password" type="password" formControlName="password"
                                                    matInput required>
                                                <mat-error>
                                                    {{'Must contain number, lowercase, uppercase letter and min. 8 characters' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="start start">
                                            <mat-form-field appearance="outline" fxFlex>
                                                <mat-label>{{'Confirm New Password' | translate }}</mat-label>
                                                <mat-icon matSuffix class="secondary-text">lock_open</mat-icon>
                                                <input name="confirmPassword" type="password"
                                                    formControlName="confirmPassword" matInput
                                                    [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="memberFirstPasswordForm.hasError('notSame')">
                                                    {{'Passwords do not match' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div>
                                            <button mat-raised-button class="mr-8" color="accent"
                                                (click)="togglePasswordDataEdit(true)">{{'Cancel' | translate }}</button>
                                            <button mat-raised-button class="mr-8" color="accent"
                                                [disabled]="memberFirstPasswordForm.invalid || memberFirstPasswordForm.pristine"
                                                (click)="savePassword(memberFirstPasswordForm)">{{'Save' | translate }}</button>
                                        </div>

                                    </form>
                                </div>
                                <div class="py-32">

                                    <button mat-raised-button class="mr-8" color="accent" *ngIf="passwordDataNoEdit"
                                        (click)="togglePasswordDataEdit(false)">{{'Create' | translate }}</button>
                                </div>
                            </div>

                            <!-- <span fxFlex fxHide.lt-md></span>

                            <div class="pb-32 mt-32 border-top" fxFlex="46" fxFlex.lt-md="100" *ngIf="gdprFlag !== 1">
                                <h3 class="text-uppercase">{{'Delete Profile' | translate}}</h3>
                                <div fxLayout="row" class="py-32">
                                    <button mat-raised-button class="mr-8" color="accent"
                                        (click)="deleteProfile()">{{'Delete' | translate}}</button>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </mat-tab>
                <mat-tab class="text-uppercase" label="{{'My Skills' | translate}}" *ngIf="profileDemogs.length > 0">
                    <div class="p-24">

                        <div fxLayout="row wrap" fxLayout.ld-md="column">

                            <div class="pb-32" fxFlex="40" fxFlex.lt-lg="45" fxFlex.lt-md="100">
                                <h3 class="text-uppercase">{{'Additional information' | translate}}</h3>
                                <div *ngIf="additionalDataNoEdit">
                                    <div class="full-content pb-32">
                                        <table class="simple">
                                            <tr *ngFor="let demog of profileDemogs">
                                                <td><b>{{demog.name | translate}}</b></td>
                                                <td *ngIf="demog.type !== 'enum'">
                                                    <ng-container *ngIf="demog.type !== 'date'">
                                                        {{demog.value ? demog.value : '-' | translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="demog.type === 'date'">
                                                        {{demog.value ? dateLocale(demog.value) : '-'}}
                                                    </ng-container>
                                                </td>
                                                <td *ngIf="demog.type === 'enum' && demog.value.length > 0">
                                                    <span
                                                        *ngFor="let item of demog.value">{{item.option | translate}}
                                                    </span>

                                                    <div class="table-container mt-8" *ngIf="demog.name === 'Member Children' && demog.value[0].option === 'Set'">
                                                        <table class="simple">
                                                            <tbody *ngIf="customDemogDataChild.length === 0">
                                                                <tr>
                                                                    <td class="empty-cell">-</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody *ngIf="customDemogDataChild.length > 0">
                                                                <tr *ngFor="let child of customDemogDataChild">
                                                                    <td [matTooltip]="child.comment" class="px-0">
                                                                        <div>{{child.first_name}} {{child.last_name}}</div>
                                                                        <div>{{child.date_of_birth}}</div>
                                                                        <div>{{child.gender}}</div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div class="table-container mt-8" *ngIf="demog.name === 'Member Spoken Language' && demog.value[0].option === 'Set'">
                                                        <table class="simple">
                                                            <tbody *ngIf="customDemogDataLang.length === 0">
                                                                <tr>
                                                                    <td class="empty-cell">-</td>
                                                                    <td class="empty-cell">-</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody *ngIf="customDemogDataLang.length > 0">
                                                                <tr *ngFor="let lang of customDemogDataLang">
                                                                    <td>{{lang.language}}</td>
                                                                    <td>{{levelDataObj[lang.level]}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div class="table-container mt-8" *ngIf="demog.name === 'Member Work Experience' && demog.value[0].option === 'Set'">
                                                        <table class="simple">
                                                            <tbody *ngIf="customDemogDataExperience.length === 0">
                                                                <tr>
                                                                    <td class="empty-cell">-</td>
                                                                    <td class="empty-cell">-</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody *ngIf="customDemogDataExperience.length > 0">
                                                                <tr *ngFor="let experience of customDemogDataExperience">
                                                                    <td>{{experience.position}}</td>
                                                                    <td>{{experience.company}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div class="table-container mt-8" *ngIf="demog.name === 'Member Education' && demog.value[0].option === 'Set'">
                                                        <table class="simple">
                                                            <tbody *ngIf="customDemogDataEducation.length === 0">
                                                                <tr>
                                                                    <td class="empty-cell">-</td>
                                                                    <td class="empty-cell">-</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody *ngIf="customDemogDataEducation.length > 0">
                                                                <tr *ngFor="let education of customDemogDataEducation">
                                                                    <td>{{education.qualification}}</td>
                                                                    <td>{{education.institution}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </td>
                                                <td *ngIf="demog.type === 'enum' && demog.value.length === 0">
                                                    <span>-</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!-- <button mat-raised-button color="accent"
                                        (click)="toggleAdditionalDataEdit(false)">{{'Edit' | translate}}</button> -->
                                </div>
                                <!-- <div *ngIf="!additionalDataNoEdit">

                                    <form [formGroup]="additionalProfileForm" autocomplete="off"
                                        *ngIf="additionalProfileForm">

                                        <div class="full-content py-32">

                                            <div *ngFor="let demog of profileDemogs; let i = index;">

                                                <div *ngIf="demog.type === 'text'">
                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>{{demog.name | translate}}</mat-label>
                                                        <input matInput [formControlName]="demog.type + demog.id">
                                                    </mat-form-field>
                                                </div>

                                                <div *ngIf="demog.type === 'number'">
                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>{{demog.name | translate}}</mat-label>
                                                        <input type="number" matInput
                                                            [formControlName]="demog.type + demog.id">
                                                    </mat-form-field>
                                                </div>

                                                <div *ngIf="demog.type === 'date'">
                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>{{demog.name | translate}}</mat-label>
                                                        <input matInput [matDatepicker]="i"
                                                            [formControlName]="demog.type + demog.id">
                                                        <mat-datepicker-toggle matSuffix [for]="i">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #i></mat-datepicker>
                                                        <mat-error>{{'Invalid date!' | translate}}</mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div fxLayout="column"
                                                    *ngIf="demog.type === 'enum' && demog.multi_select">
                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>{{demog.name | translate}}</mat-label>
                                                        <mat-select [formControlName]="demog.type + demog.id + 'ms'"
                                                            multiple [required]="demog.source.length > 0">
                                                            <mat-option *ngFor="let enum of demog.source"
                                                                [value]="enum.id">{{enum.option | translate}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="additionalProfileForm.get(demog.type + demog.id + 'ms').hasError('required')">
                                                            {{'A choice is reqired' | translate}}
                                                        </mat-error>
                                                    </mat-form-field>
                                                    <div *ngIf="demog.source.length === 0">
                                                        {{'No defined options' | translate}}
                                                    </div>
                                                </div>

                                                <div class="pl-16 pb-16"
                                                    *ngIf="demog.type === 'enum' && !demog.multi_select">
                                                    <mat-label><b>{{demog.name | translate}}</b></mat-label>
                                                    <mat-radio-group [formControlName]="demog.type + demog.id"
                                                        [required]="demog.source.length > 0" fxLayout="column"
                                                        class="py-16">
                                                        <mat-radio-button *ngFor="let enum of demog.source"
                                                            [value]="enum.id" class="my-4">
                                                            {{enum.option | translate}}
                                                        </mat-radio-button>
                                                    </mat-radio-group>
                                                    <mat-error
                                                        *ngIf="additionalProfileForm.get(demog.type + demog.id).hasError('required')">
                                                        {{'A choice is reqired' | translate}}
                                                    </mat-error>
                                                    <div *ngIf="demog.source.length === 0">
                                                        {{'No defined options' | translate}}
                                                    </div>
                                                </div>

                                            </div>

                                            <div fxLayout="row">
                                                <button mat-raised-button class="mr-8" color="accent"
                                                    (click)="toggleAdditionalDataEdit(true)">{{'Cancel' | translate}}</button>
                                                <button mat-raised-button color="accent"
                                                    [disabled]="additionalProfileForm.invalid || additionalProfileForm.pristine"
                                                    (click)="saveAdditionalProfile(additionalProfileForm)">{{'Update' | translate}}</button>
                                            </div>

                                        </div>

                                    </form>

                                </div> -->

                            </div>
                            <span fxFlex fxHide.lt-md></span>
                            <div class="pb-32" fxFlex="48" fxFlex.lt-md="100">
                                <h3 class="text-uppercase">{{'SKILLS' | translate }}</h3>

                                <div *ngFor="let group of skillGroups" class="mb-32">

                                    <!-- <button mat-raised-button color="accent" class="my-16"
                                        (click)="assignSkillToMember(group);">{{'Assign' | translate }}
                                        {{group | translate}}</button> -->

                                    <div class="my-16">
                                        <mat-chip-list #chipList>
                                            <mat-chip removable="false" *ngFor="let chip of memberSkills[group]"
                                                selected>
                                                <!-- (removed)="removeMemberSkill(chip,group)" -->
                                                {{chip.name | translate }}
                                                <!-- <mat-icon matChipRemove>close</mat-icon> -->
                                            </mat-chip>
                                        </mat-chip-list>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </mat-tab>

                <mat-tab class="text-uppercase" label="{{'Application status' | translate}}"
                    *ngIf="projectsData.length > 0">
                    <div class="p-24">
                        <div class="full-content">
                            <table class="simple application-table">
                                <tr>
                                    <th>{{'Workplace' | translate}}</th>
                                    <th fxHide.lt-md>{{'Company' | translate}}</th>
                                    <th fxHide.lt-md>{{'Status' | translate}}</th>
                                </tr>

                                <tr *ngFor="let project of projectsData">
                                    <td>
                                        <div>{{project.positionName | translate}}</div>
                                        <small fxHide fxShow.lt-md>{{project.employName}}<span
                                                *ngIf="project.cityName">, {{getCity(project.cityName)}}</span>
                                        </small>
                                    </td>
                                    <td fxHide.lt-md>{{project.employName}}<span *ngIf="project.cityName">
                                            ({{getCity(project.cityName)}})</span></td>
                                    <td>{{project.stationName | translate}}</td>
                                </tr>

                            </table>

                        </div>
                        <div class="full-content" *ngIf="projectsData.length === 0">
                            {{'You have no sign-ups for ads.' | translate}}
                        </div>
                    </div>
                </mat-tab>

                <mat-tab label="{{'My Documents' | translate}}">

                    <div class="tab-content p-24" fxLayout="column" fusePerfectScrollbar>

                        <div class="my-32">
                            <table class="simple documents-table">
                                <thead>
                                    <tr>
                                        <th>{{'File name' | translate}}</th>
                                        <!-- <th>Name</th>
                                        <th>Type</th> -->
                                        <th>{{'Date' | translate}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="cvFile.id">
                                        <td data-label="Filename">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxHide.xs>
                                                <mat-icon class="s-32 mr-8">{{cvFile.icon}}</mat-icon>
                                                <span>{{cvFile.file_name}}</span>
                                            </div>
                                            <span class="text-truncate" fxHide fxShow.xs>{{cvFile.file_name}}</span>
                                        </td>
                                        <!-- <td data-label="Name">
                                            <span class="text-truncate">{{cvFile.name}}</span>
                                        </td>
                                        <td data-label="Type">
                                            <span class="text-truncate">{{cvFile.mime_type}}</span>
                                        </td> -->
                                        <td data-label="Date">
                                            <span class="text-truncate">{{dateLocale(cvFile.updated)}}</span>
                                        </td>
                                        <td data-label="" class="text-nowrap">
                                            <button mat-icon-button (click)="downloadCv(cvFile.file_name)">
                                                <mat-icon>arrow_downward</mat-icon>
                                            </button>
                                            <!-- <button mat-icon-button (click)="deleteAsset(cvFile.id, 'cv')">
                                                <mat-icon>close</mat-icon>
                                            </button> -->
                                        </td>
                                    </tr>
                                    <tr *ngIf="!cvFile.id">
                                        <td colspan="5" class="empty">{{'No data' | translate}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="my-32">
                            <table class="simple documents-table">
                                <thead>
                                    <tr>
                                        <th>{{'File name' | translate}}</th>
                                        <!-- <th>Name</th>
                                        <th>Type</th> -->
                                        <th>{{'Date' | translate}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of docFiles">
                                        <td data-label="Filename">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxHide.xs>
                                                <mat-icon class="s-32 mr-8">{{item.icon}}</mat-icon>
                                                <span class="text-truncate">{{item.filename}}
                                                </span>
                                            </div>
                                            <span class="text-truncate" fxHide fxShow.xs>{{item.filename}}</span>
                                        </td>
                                        <!-- <td data-label="Name">
                                            <span class="text-truncate">{{item.name}}</span>
                                        </td> -->
                                        <!-- <td data-label="Type">
                                            <span class="text-truncate">{{item.type}}</span>
                                        </td> -->
                                        <td data-label="Date">
                                            <span class="text-truncate">{{dateLocale(item.updated)}}</span>
                                        </td>
                                        <td data-label="" class="text-nowrap">
                                            <button mat-icon-button
                                                (click)="downloadAsset(item.id, 'doc', item.filename)">
                                                <mat-icon>arrow_downward</mat-icon>
                                            </button>
                                            <!-- <button mat-icon-button (click)="deleteAsset(item.id, 'doc')">
                                                <mat-icon>close</mat-icon>
                                            </button> -->
                                        </td>
                                    </tr>
                                    <tr *ngIf="docFiles.length === 0">
                                        <td colspan="5" class="empty">{{'No data' | translate}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </mat-tab>
            </mat-tab-group>




        </div>
    </div>

</div>